import { FC, HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Button, Flex, Tooltip } from 'antd';

import LinkIcon from 'assets/images/icons/link.svg?react';
import { IBrand } from 'entities/Brand';
import { IOffer, JoinButton } from 'entities/Offer';
import { EFilters } from 'features/Filters';
import { useMedia } from 'shared/hooks';
import { EMainRoutes } from 'shared/typings';

interface IButtonsBarProps extends HTMLAttributes<HTMLDivElement> {
	isSinglePage?: boolean;
	brand?: IBrand;
	offer?: IOffer;
	isBottom?: boolean;
}

export const ButtonsBar: FC<IButtonsBarProps> = ({ isSinglePage, brand, offer, isBottom }) => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const isMd = useMedia();

	return (
		<Flex gap={8} justify="end">
			{isSinglePage && (
				<>
					{brand && (
						<Button
							type={isMd ? 'default' : 'text'}
							size={isMd ? 'small' : 'middle'}
							onClick={() => navigate(`/${EMainRoutes.CATALOG}/?${EFilters.BRAND}=${brand?.uuid}`)}>
							{t('Другие офферы бренда')} ({brand?.offers.length})
						</Button>
					)}
					<JoinButton brand={brand} offer={offer} isBottom={isBottom} />
				</>
			)}

			{!isSinglePage && (
				<>
					<Tooltip title={t('Подробнее про оффер')}>
						<Button
							href={`/${EMainRoutes.CATALOG}/${EMainRoutes.OFFER}/${offer?.uuid}`}
							target="_blank"
							icon={<LinkIcon />}
							variant="dashed"
							size={isMd ? 'small' : 'middle'}
							color="primary"
						/>
					</Tooltip>
					<JoinButton brand={brand} offer={offer} isBottom={isBottom} />
				</>
			)}
		</Flex>
	);
};
